import { client } from '../client';
import { Organization } from './types/UserProfile';

export const getCurrentOrganization = async (): Promise<Organization> => {
  const { data } = await client.get('/organizations/current');

  return data;
};
